module.exports = __webpack_public_path__ + "img/strike.e93be34b.svg";